import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { StepIds } from '../../../models/property-step/property-step-model';
import { PropertyAboutSectionComponent } from '../../../sections/property-default-sections/property-about-section/property-about-section.component';
import { DraftFacade, RouterFacade } from '@classifieds-sell/state';
import { PropertyPageBase } from '../../property-page-base';
import { PropertySaleAttributeSectionComponent } from '../../../sections/residential-for-sale/property-sale-attribute-section/property-sale-attribute-section.component';
import { PropertyListingTitleSectionComponent } from '../../../sections/residential-for-sale/property-listing-title-section/property-listing-title-section.component';

@Component({
    templateUrl: './property-description-page.component.html',
    styleUrls: ['./property-description-page.component.scss']
})
export class ResidentialForSalePropertyDescriptionComponent
    extends PropertyPageBase
    implements AfterViewInit, OnInit, OnDestroy {
    sideCardIcon = '/sell/property/assets/property-ui/hands.svg';
    sideCardHeading =
        'Feeling stuck? Here’s a few things buyers are looking for:';
    sideCardCallToActionText = 'View the full guide';
    sideCardCallToActionLink =
        'https://www.trademe.co.nz/c/property/article/how-to-list-a-property-on-trade-me-when-selling-privately';

    @ViewChild(PropertyListingTitleSectionComponent, {
        read: PropertyListingTitleSectionComponent
    })
    propertyListingTitleSectionComponent: PropertyListingTitleSectionComponent;

    @ViewChild(PropertyAboutSectionComponent, {
        read: PropertyAboutSectionComponent
    })
    propertyAboutSectionComponent: PropertyAboutSectionComponent;

    @ViewChild(PropertySaleAttributeSectionComponent, {
        read: PropertySaleAttributeSectionComponent
    })
    propertySaleAttributeSectionComponent: PropertySaleAttributeSectionComponent;

    constructor(draftFacade: DraftFacade, routerFacade: RouterFacade) {
        super(StepIds.propertyDescription, draftFacade, routerFacade);
    }

    ngOnInit(): void {
        super.onInit();
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }

    ngAfterViewInit() {
        super.registerSection(this.propertyListingTitleSectionComponent);
        super.registerSection(this.propertyAboutSectionComponent);
        super.registerSection(this.propertySaleAttributeSectionComponent);
    }
}
